import {
  gridPanelClosed,
  gridPanelOpened,
  selectAvailableTabs,
  selectAvailableTabsCount,
  selectLastOpenedContent,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { call, put, select } from 'redux-saga/effects';
import { openLastActiveWhiteboardSaga } from 'features/content-library/sagas/openLastActiveWhiteboardSaga';
import { openLastActiveFileSaga } from 'features/content-library/sagas/openLastActiveFileSaga';
import { openLastActiveScreenshareSaga } from 'features/screenshare/sagas/openLastActiveScreenshareSaga';
import { findContentForStageSaga } from 'features/layout/sagas/findContentForStageSaga';
import { ContentData, GridPanelName } from 'features/layout/features/content/types';
import { navigateToLockedContentSaga } from 'features/layout/features/content/sagas/navigateToLockedContentSaga';

export function* openLastActiveContentSaga() {
  const lockedContent: ContentData | null = yield select(selectLockedContent);

  if (lockedContent) {
    yield call(navigateToLockedContentSaga);

    return;
  }

  const latestContent: GridPanelName | null = yield select(selectLastOpenedContent);
  const availableTabs: Record<GridPanelName, boolean> = yield select(selectAvailableTabs);

  if (availableTabs.external && latestContent === 'external') {
    yield put(gridPanelOpened('external'));
    return;
  }

  if (availableTabs.whiteboard && latestContent === 'whiteboard') {
    yield call(openLastActiveWhiteboardSaga);
    return;
  }

  if (availableTabs.contentLibrary && latestContent === 'contentLibrary') {
    yield call(openLastActiveFileSaga);
    return;
  }

  if (availableTabs.screenshare && latestContent === 'screenshare') {
    yield call(openLastActiveScreenshareSaga);
    return;
  }

  const availableTabsCount: number = yield select(selectAvailableTabsCount);

  if (availableTabsCount === 0) {
    yield put(gridPanelClosed());
    yield call(findContentForStageSaga);
  }
}
